module.exports = __webpack_public_path__ + "img/connector-types.c3cf478f.png";